module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-about-doctor"
  }, [_c('div', {
    staticClass: "tabs-about-doctor__bg"
  }, [_c('div', {
    staticClass: "tabs-about-doctor__container"
  }, [_c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.onWaypointTitle,
        options: _vm.intersectionTitleOptions
      }),
      expression: "{ active: true, callback: onWaypointTitle, options: intersectionTitleOptions }"
    }],
    staticClass: "tabs-about-doctor__title",
    class: {
      "tabs-about-doctor__title--active": _vm.fadeTitle
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "tabs-about-doctor__col--left"
  }, [_c('div', {
    staticClass: "tabs-about-doctor__selectors"
  }, _vm._l((_vm.props.bio), function(selector, i) {
    return _c('div', {
      key: i,
      staticClass: "tabs-about-doctor__selector",
      on: {
        "click": function($event) {
          _vm.selectBio(i)
        },
        "mouseover": function($event) {
          _vm.selectBio(i)
        }
      }
    }, [_c('div', {
      staticClass: "tabs-about-doctor__icon-circle",
      class: {
        "tabs-about-doctor__icon-circle--active": _vm.showBio === i
      }
    }, [_c('Icon', {
      staticClass: "tabs-about-doctor__icon",
      class: {
        "tabs-about-doctor__icon--active": _vm.showBio === i
      },
      attrs: {
        "name": selector.icon
      }
    })], 1), _c('div', {
      staticClass: "tabs-about-doctor__label",
      class: {
        "tabs-about-doctor__label--active": _vm.showBio === i
      },
      domProps: {
        "innerHTML": _vm._s(selector.label)
      }
    }), _c('div', {
      staticClass: "tabs-about-doctor__underline",
      class: {
        "tabs-about-doctor__underline--active": _vm.showBio === i
      }
    }, [_c('div', {
      staticClass: "tabs-about-doctor__orange-underline"
    })])])
  })), _c('div', {
    staticClass: "tabs-about-doctor__bio"
  }, [_vm._l((_vm.props.bio), function(bio, j) {
    return (_vm.showBio === j) ? _c('div', {
      key: j,
      staticClass: "tabs-about-doctor__bio-content"
    }, [_c('ul', _vm._l((bio.content), function(item) {
      return _c('li', {
        staticClass: "tabs-about-doctor__item"
      }, [_c('span', [_vm._v(_vm._s(item.item))])])
    }))]) : _vm._e()
  }), _c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.onWaypointLine,
        options: _vm.intersectionLineOptions
      }),
      expression: "{ active: true, callback: onWaypointLine, options: intersectionLineOptions }"
    }],
    staticClass: "tabs-about-doctor__seperator",
    class: {
      "tabs-about-doctor__seperator--active": _vm.fadeLine
    }
  }, [_c('div', {
    staticClass: "tabs-about-doctor__orange-line"
  })])], 2)]), _c('div', {
    staticClass: "tabs-about-doctor__col--right"
  }, [_c('div', {
    staticClass: "tabs-about-doctor__image",
    style: ("background-image: url(" + _vm.props.image + ");")
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-793cb56b","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/tabs/tabs-about-doctor/tabs-about-doctor.pug
// module id = 590
// module chunks = 1